"use client"
import Link from "next/link"
import DocumentForm from "../forms/DocumentForm"
import Image from "next/image"
import { useLanguage } from "@/utils/LanguageContext"

import docShape from "@/assets/img/update/hero/invtron.png"

interface DocData {
  name: string
  url: string
}

const doc_data: DocData[] = [
  {
    name: "Whitepaper",
    url: "/flipbook/whitepaper",
  },
  {
    name: "Token Sale Terms",
    url: "/terms",
  },
  {
    name: "Pitch Deck",
    url: "/flipbook/pitch-deck",
  },
  {
    name: "Lightpaper",
    url: "/flipbook/litepaper",
  },
]

const DocumentArea = () => {
   const { t } = useLanguage();

   const handleDownloadAll = () => {
      if (typeof window === "undefined") return
      const urls = [
         "https://invtron.com/Litepaper.pdf",
         "/White-Paper.pdf",
         "/Pitch-Deck.pdf",
      ]
      urls.forEach((u) => {
         const a = document.createElement("a")
         a.href = u
         a.download = ""
         document.body.appendChild(a)
         a.click()
         document.body.removeChild(a)
      })
   }

   return (
      <section className="document-area">
         <div className="container">
            <div className="document-inner-wrap">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="section-title text-center mb-60">
                        <h2 className="title">{t("Have Any Questions?")}</h2>
                     </div>
                  </div>
               </div>
               <div className="row">
                  <div className="col-lg-8">
                     <div className="document-form-wrap">
                        <h4 className="title">{t("Get In Touch Now")}</h4>
                        <DocumentForm />
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="document-wrap">
                        <h4 className="title">{t("Read Documents")}</h4>
                        <ul className="list-wrap">
                           {doc_data.map((doc, i) => (
                              <li key={i}>
                                 <Link href={doc.url} target="_blank" rel="noopener noreferrer">
                                    <span className="icon"><i className="fas fa-file-pdf"></i></span>
                                    {t(doc.name)}
                                 </Link>
                              </li>
                           ))}
                        </ul>
                        <button type="button" className="btn" onClick={handleDownloadAll}>
                           {t("Download All")}
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="document-shape">
            <Image src={docShape} alt="" className="alltuchtopdown" />
         </div>
      </section>
   )
}

export default DocumentArea
